import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-obs-social-executive',
  templateUrl: './obs-social-executive.component.html',
  styleUrls: ['./obs-social-executive.component.css'],
})
export class ObsSocialExecutiveComponent implements OnInit {
  loading = false;

  // desde SocialObservabilitySnapshot
  healthState: string = 'SOCIAL_HEALTHY';
  activeSignals: string[] = [];

  postsPublished: number = 0;
  postsScheduled: number = 0;

  validLeadRate: number = 0;
  invalidLeadRate: number = 0;

  bookingStarted: number = 0;
  bookingCompleted: number = 0;

  inventoryReady: number = 0;
  refreshDue: number = 0;

  // desde from SocialAssetMetricSnapshot
  topAssets: Array<any> = [];

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/observability/seo/metricsDaily',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/observability/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/observability/social',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'MEDIAROOM',
      route: '/observability/mediaroom',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'LOGISTICS',
      route: '/observability/logistics',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-receipt',
      bgClass: 'bg-white',
      desc: 'ACCOUNTING',
      route: '/observability/accounting',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-coins',
      bgClass: 'bg-white',
      desc: 'FINANCE',
      route: '/observability/finance',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'HR',
      route: '/observability/hr',
    },
  ];

  healthStateMap: Record<string, { label: string; badgeClass: string }> = {
    SOCIAL_HEALTHY: { label: 'Healthy', badgeClass: 'badge-healthy' },
    SOCIAL_WATCH: { label: 'Watch', badgeClass: 'badge-watch' },
    SOCIAL_DEGRADED: { label: 'Degraded', badgeClass: 'badge-degraded' },
    SOCIAL_SAFE_STATE_ACTIVE: {
      label: 'Safe State Active',
      badgeClass: 'badge-safe-state',
    },
  };

  constructor(
    private dataService: DataService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  getData() {
    this.loading = true;

    // Ejecutamos ambas peticiones en paralelo
    const obsReq = this.dataService.getData('socialObservability/scorecards?limit=1');
    const topAssetsReq = this.dataService.getData('socialMetrics/top?limit=5&metric=engagement_rate');

    forkJoin([obsReq, topAssetsReq]).subscribe(
      ([obsRes, topRes]: [any, any]) => {
        
        // 1. Snapshot de Observabilidad
        if (obsRes && obsRes.rst && obsRes.data.length > 0) {
          const execSnapshot = obsRes.data[0];
          
          this.healthState = execSnapshot.health_state || 'SOCIAL_HEALTHY';
          this.activeSignals = execSnapshot.active_signals || [];

          this.postsPublished = execSnapshot.posts_published_count || 0;
          this.postsScheduled = execSnapshot.posts_scheduled_count || 0;

          this.validLeadRate = execSnapshot.valid_lead_rate || 0;
          this.invalidLeadRate = execSnapshot.invalid_lead_rate || 0;

          this.bookingStarted = execSnapshot.booking_flow_started_count || 0;
          this.bookingCompleted = execSnapshot.booking_completed_count || 0;

          this.inventoryReady = execSnapshot.inventory_ready_count || 0;
          this.refreshDue = execSnapshot.refresh_due_count || 0;
        } else {
          this.messageService.add("No se pudo obtener el estado de observabilidad", 'secondary');
        }

        // 2. Métricas del Top de Assets
        if (topRes && topRes.rst) {
          this.topAssets = topRes.data.map((item: any) => {
            // El backend retorna un modelo populado, así que extraemos o parseamos como sea necesario
            return {
              platform: item.platform,
              platform_post_id: item.platform_post_id || item.social_asset_id?.title_internal || 'N/A',
              window: item.window || 'all',
              link_clicks: item.link_clicks || 0,
              dm_starts: item.dm_starts || 0,
              engagement_rate: item.engagement_rate || 0,
            };
          });
        } else {
           this.messageService.add("No se pudo obtener el top de assets", 'secondary');
        }

        this.loading = false;
      },
      (error: any) => {
        this.loading = false;
        this.messageService.add("Error al cargar los datos del backend", 'danger');
        console.error(error);
      }
    );
  }

  get healthBadge() {
    return (
      this.healthStateMap[this.healthState] ?? {
        label: this.healthState,
        badgeClass: 'badge-healthy',
      }
    );
  }

  formatPercent(value: number): string {
    return (value * 100).toFixed(1) + '%';
  }
}
